import {
  APP_SETTING_SAVE_CSS_FILE_BEGIN,
  APP_SETTING_SAVE_CSS_FILE_SUCCESS,
  APP_SETTING_SAVE_CSS_FILE_FAILURE,
  APP_SETTING_SAVE_CSS_FILE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function saveCssFile(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_SAVE_CSS_FILE_BEGIN,
    });

    const header = {
      'Content-Type': 'multipart/form-data',
    };
    const { projectId, version, cssUuid, formData, customCssCdnData } = args;
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/${customCssCdnData.customType}/custom-css-cdn/files/${cssUuid}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(url, formData, { headers: header });
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_SAVE_CSS_FILE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: APP_SETTING_SAVE_CSS_FILE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveCssFileError() {
  return {
    type: APP_SETTING_SAVE_CSS_FILE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_SAVE_CSS_FILE_BEGIN:
      return {
        ...state,
        saveCssFilePending: true,
        saveCssFileError: null,
      };

    case APP_SETTING_SAVE_CSS_FILE_SUCCESS:
      return {
        ...state,
        saveCssFilePending: false,
        saveCssFileError: null,
      };

    case APP_SETTING_SAVE_CSS_FILE_FAILURE:
      return {
        ...state,
        saveCssFilePending: false,
        saveCssFileError: action.data.error,
      };

    case APP_SETTING_SAVE_CSS_FILE_DISMISS_ERROR:
      return {
        ...state,
        saveCssFileError: null,
      };

    default:
      return state;
  }
}
